import { gql } from '@apollo/client';

import sampleEvent from 'api/sample-events/sampleEvent';

export const SAMPLE_EVENT_QUERY = 'SampleEvent';

export const GET_SAMPLE_EVENT = gql`
  query ${SAMPLE_EVENT_QUERY}($id: uuid!) {
    sampleEvent: sample_events_by_pk(id: $id) {
      ...sampleEvent
    }
  }
  ${sampleEvent}
`;
